import Icon1 from '~/assets/svg/sustentabilidade/Iluminacao.svg'
import Icon2 from '~/assets/svg/sustentabilidade/Sem-desperdicio.svg'
import Icon3 from '~/assets/svg/sustentabilidade/Carro-eletrico.svg'
import Icon4 from '~/assets/svg/sustentabilidade/Torneira.svg'
import Icon5 from '~/assets/svg/sustentabilidade/Duplo.svg'
// import Icon6 from '~/assets/svg/sustentabilidade/Bike-eletrica.svg'
import Icon7 from '~/assets/svg/sustentabilidade/Hidrometro.svg'
import Icon8 from '~/assets/svg/sustentabilidade/Reciclagem.svg'
import Icon9 from '~/assets/svg/sustentabilidade/Energia.svg'

export default [
  {
    icon: Icon1,
  },
  {
    icon: Icon2,
  },
  {
    icon: Icon3,
  },
  {
    icon: Icon4,
  },
  {
    icon: Icon5,
  },
  {
    icon: Icon9,
  },
  {
    icon: Icon7,
  },
  {
    icon: Icon8,
  },
  // {
  //   icon: Icon6,
  // },
]
